import { createGlobalStyle } from 'styled-components'

import { fontFamily, fontWeight, fontSize } from './fonts'

export default createGlobalStyle`
  html {
    font-size: 62.5%;
  }

  html, body, #__next {
    height: 100%;
  }

  body {
    font-family: ${fontFamily.CATAMARAN}, sans-serif;
    font-weight: ${fontWeight.REGULAR};
    font-size: ${fontSize.NORMAL};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  #root {
    height: 100%;
  }

  button {
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
  }

  a {
    text-decoration: none;
  }

  *, ::before, ::after {
    box-sizing: border-box;
  }

  /* Fonts */
  @font-face {
    font-family: 'Catamaran';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/catamaran/v6/o-0IIpQoyXQa2RxT7-5r5TRASf6M7Q.woff2) format('woff2');
  }

  @font-face {
  font-family: 'Catamaran';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/catamaran/v6/o-0NIpQoyXQa2RxT7-5jFhdVZNyBx2pqPA.woff2) format('woff2');
}

  @font-face {
  font-family: 'Catamaran';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/catamaran/v6/o-0NIpQoyXQa2RxT7-5jOhBVZNyBx2pqPA.woff2) format('woff2');
}

  @font-face {
    font-family: 'Catamaran';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/catamaran/v6/o-0NIpQoyXQa2RxT7-5jXhFVZNyBx2pqPA.woff2) format('woff2');
  }

  @font-face {
    font-family: 'Catamaran';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/catamaran/v6/o-0NIpQoyXQa2RxT7-5jQhJVZNyBx2pqPA.woff2) format('woff2');
  }

  @font-face {
    font-family: 'Catamaran';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/catamaran/v6/o-0NIpQoyXQa2RxT7-5jZhNVZNyBx2pqPA.woff2) format('woff2');
  }
`
